import { render, staticRenderFns } from "./DocumentsList.vue?vue&type=template&id=270497c0&scoped=true"
import script from "./DocumentsList.vue?vue&type=script&lang=js"
export * from "./DocumentsList.vue?vue&type=script&lang=js"
import style0 from "./DocumentsList.vue?vue&type=style&index=0&id=270497c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270497c0",
  null
  
)

export default component.exports